import { CANCEL_FETCH_MESSAGE } from 'hb-react/shared/constants/cancelFetch';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

import { HTTP_STATUS_CODE_403 } from '../constants/httpStatusCode';
import handleDisplayErrorToast from '../utils/handleDisplayErrorToast';

const fetchSuperCategories = ({ format = 'json', cancelToken }) =>
  axios
    .get(
      Routes.topics_category_sets_path({
        format,
      }),
      {
        cancelToken: cancelToken?.token,
      },
    )
    .then(
      ({
        data: {
          category_sets: superCategories,
          category_sets_count: superCategoriesCount,
        },
      }) => ({
        superCategories,
        superCategoriesCount,
      }),
    )
    .catch((error) => {
      if (error.message === CANCEL_FETCH_MESSAGE) {
        return null;
      }

      if (error.response.status !== HTTP_STATUS_CODE_403) {
        handleDisplayErrorToast(error);
      }

      return error;
    });

export default fetchSuperCategories;
